import { useInView } from 'react-intersection-observer';

// Dispara cuando el borde superior de la sección entra al 85% de la pantalla.
// Un umbral por porcentaje (ej. 0.2) nunca se cumple en secciones más altas que 5 pantallas.
export const useScrollAnimation = () => {
  const [ref, inView] = useInView({ threshold: 0, rootMargin: '0px 0px -15% 0px', triggerOnce: true });
  return { ref, inView };
};

export const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.4, 0, 0.2, 1] } }
};

export const fadeInLeft = {
  hidden: { opacity: 0, x: -40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: [0.4, 0, 0.2, 1] } }
};

export const fadeInRight = {
  hidden: { opacity: 0, x: 40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: [0.4, 0, 0.2, 1] } }
};

export const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } }
};
